const waitForSifu = (resolve, max = 10, intervalMs = 100, i = 0) => {
  if (window.SF || i >= max) {
    resolve()
  } else {
    setTimeout(() => waitForSifu(resolve, max, intervalMs, i + 1), intervalMs)
  }
}

export default waitForSifu
